var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        action: "#",
        accept: _vm.isVideo ? ".mp4" : ".jpg,.jpeg,.png,.bmp,.gif",
        limit: _vm.limit,
        multiple: !_vm.isVideo,
        disabled: _vm.disabled,
        "file-list": _vm.files,
        "before-upload": _vm.beforeUpload,
        "before-remove": _vm.beforeRemove,
        "http-request": _vm.upload,
        "on-change": _vm.handleChange,
        "on-remove": _vm.handleChange,
        "on-exceed": _vm.handleExceed,
      },
    },
    [
      _c("el-button", { attrs: { size: "small", disabled: _vm.disabled } }, [
        _vm._v(_vm._s(_vm.isVideo ? "上传录屏" : "上传图片")),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "el-upload__tip", attrs: { slot: "tip" }, slot: "tip" },
        [
          _vm._v(
            "\n    最多" +
              _vm._s(_vm.limit) +
              _vm._s(_vm.isVideo ? "个mp4视频" : "张图片") +
              "，单个文件不超过" +
              _vm._s(_vm.maxMegabytes) +
              "MB。请在本次提审前上传，勿长期复用素材ID。\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }